// §18 F1 — "tray shows *'Offline — changes will sync when you're back'*".
//
// One shared shell component placed by each skin's sheet, for the same reason the clipboard panel
// and the notification Center are (D-135, D-140): §6.1's component list is closed and has no entry
// for this, and what it *says* is identical under every skin. What differs is where the tray is,
// which is a `:root[data-skin=…]` rule.
//
// It appears only for a signed-in session that cannot reach its server. A guest has nothing to
// sync (§7.4), so telling one their changes will sync later would be a promise nobody is keeping.
import { COPY } from '@/copy';
import { useKernel, useStoreValue } from '@/kernel/react';

export function SyncChip() {
  const kernel = useKernel();
  const status = useStoreValue(kernel.sync.store, (state) => state.status);

  if (status !== 'offline') return null;

  return (
    <div className="sync-chip" role="status" data-testid="sync-chip">
      <span className="sync-chip-dot" aria-hidden="true" />
      <span className="sync-chip-message" data-testid="sync-chip-message">
        {COPY.offline}
      </span>
    </div>
  );
}
